import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import { isLoading, load, get } from '../reducers/going';

import HorseRacingGoing from '../components/HorseRacingGoing';

@layoutAsyncConnect(
  "HorseRacingGoingContainer",
  [{
    dispatch: () => load(),
    preventResolve: ({state}) => isLoading(state),
    state: state => ({going: get(state)})
  }]
)
export default class HorseRacingGoingContainer extends Component {
  static propTypes = {
    going: PropTypes.object
  }

  render() {
    return <HorseRacingGoing races={this.props.going}/>
  }
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingGoingContainer.js